import styled from 'styled-components';

const labelManageStyled = styled.div`
  display: flex;
  gap: 24px;
  justify-content: space-between;
  /* height: 100%; */
  width: 100%;
  overflow: hidden;
  flex-grow: 1;
  .search-condition-left {
    width: 296px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 23px;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    max-height: calc(100vh - 151px);
    overflow-y: auto;
    .ant-tree-treenode {
      padding: 10px 16px;
      .ant-tree-title {
        width: 63px;
        /* height: 23px; */
        font-size: 16px;
        font-weight: 400;
        color: #212121;
        line-height: 23px;
      }
      .ant-tree-node-content-wrapper {
        word-break: break-all;
      }
    }
  }
`;
export default labelManageStyled;
